import axios from "axios";

export default class PostcardImageService {
    static createPostcardImage(formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .post('/postcard_image',
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }


    static deletePostcardImage(id: number) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/postcard_images/${id}`)
                .then((res) => {
                    resolve(id);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/PostcardImageService.ts